<div class="checkbox-filter-container" *ngIf="showOfferExclusiveFilter">
  <app-box-filter [index]="index" [label]="'HOTELS_MODULE.FILTER_HOTELS.EXCLUSIVE_OFFER' | transloco" [show]="isOpenBox"
    (toggleShow)="toggleCheckboxOptions()">
    <div class="list-container" [class.active]="isOpenBox">
      <div class="checkbox-list full-view">
        <div class="checkbox">
          <app-ds-checkbox
            [checked]="exclusiveOffer"
            [title]="{ Label: offerLabel | transloco }"
            [icon]="offerIcon"
            [align]="checkboxAlign"
            [counter]="total"
            (checkboxOnChecked)="select()">
          </app-ds-checkbox>
        </div>
      </div>
    </div>
  </app-box-filter>
</div>